export default {
  teeny: '330px',
  nano: '450px',
  insect: '675px',
  fish: '900px',
  hooman: '1200px',
};
